<template>
  <v-app-bar app :color="getHeaderColor" height="80" :flat="isFlat">
    <v-app-bar-nav-icon v-if="isSmallScreen" @click="navDrawerIconClick()" class="anchor--text"></v-app-bar-nav-icon>
    <v-navigation-drawer v-model="navDrawer" class="color2" temporary absolute app>
      <router-link :to="getHomeLink()" tag="span" style="cursor:pointer">
        <v-list-item two-line @click="navDrawerHomeClick()">
          <app-logo></app-logo>
          <v-list-item-title class="anchor--text navDrawerTitle">
            <h1>{{ $t("drRashmee") }}</h1>
          </v-list-item-title>
        </v-list-item>
      </router-link>
      <v-divider color="black"></v-divider>
      <v-list nav>
        <v-list-item-group>
          <v-list-item
            v-for="(tab, idx) in commonTabs"
            :key="idx"
            router
            :to="getRouterTo(tab.routerLink)"
            @click="navDrawerItemClick(tab.routerLink)"
          >
            <v-list-item-icon>
              <v-icon>{{ tab.icon }}</v-icon>
            </v-list-item-icon>
            <span class="anchor--text navDrawerTabName">{{ $t(tab.name) }}</span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider color="black"></v-divider>
    </v-navigation-drawer>
    <app-logo></app-logo>
    <div>
      <router-link :to="getHomeLink()" tag="span" style="cursor:pointer" @click="appNameClick()">
        <h1 v-if="longName" id="title" class="anchor--text">{{ $t("drRashmeeRajkarnikar") }}</h1>
        <h3 v-if="shortName" id="title" class="anchor--text">{{ $t("drRashmee") }}</h3>
      </router-link>
    </div>
    <v-spacer></v-spacer>
    <app-header-tabs v-if="!isSmallScreen"></app-header-tabs>
    <app-user-tabs v-if="!isSmallScreen"></app-user-tabs>
    <app-lang-switcher></app-lang-switcher>
  </v-app-bar>
</template>

<script>
import LangSwitcher from "@/components/header/LangSwitcher";
import Logo from "@/components/header/Logo";
import HeaderTabs from "@/components/header/HeaderTabs";
import UserTabs from "@/components/header/UserTabs";
import { mapGetters } from "vuex";

export default {
  name: "Header",
  components: {
    appLangSwitcher: LangSwitcher,
    appUserTabs: UserTabs,
    appLogo: Logo,
    appHeaderTabs: HeaderTabs,
  },
  data() {
    return {
      navDrawer: false,
    };
  },
  computed: {
    ...mapGetters(["commonTabs", "getWindowWidth", "getScrollY"]),
    getHeaderColor() {
      if (this.getScrollY <= 10) {
        return "color1";
      }
      return "color2";
    },
    isFlat() {
      if (this.getScrollY <= 10) {
        return true;
      }
      return false;
    },
    isSmallScreen() {
      if (this.getWindowWidth <= 875) {
        return true;
      }
      return false;
    },
    longName() {
      if (this.getWindowWidth >= 1105) {
        return true;
      }
      return false;
    },
    shortName() {
      if (this.getWindowWidth < 1105) {
        if (this.getWindowWidth > 735) {
          return true;
        } else if (this.getWindowWidth < 875) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    getHomeLink() {
      return "/" + this.$i18n.locale + "/";
    },
    getRouterTo(routerLink) {
      var routeObj = {
        name: routerLink,
        params: {
          lang: this.$i18n.locale,
        },
      };
      if (routerLink === "myWork") {
        routeObj.params.type = "thesis";
      }
      return routeObj;
    },
    navDrawerIconClick() {
      this.navDrawer = !this.navDrawer;
      this.logEvent("button_click", {
        name: "navDrawerIcon",
      });
    },
    navDrawerHomeClick() {
      this.logEvent("element_click", {
        name: "navDrawerHome",
        link: "home",
      });
    },
    navDrawerItemClick(link) {
      this.logEvent("element_click", {
        name: "navDrawerItem",
        link: link,
      });
    },
    appNameClick() {
      this.logEvent("element_click", {
        name: "appName",
        link: "home",
      });
    },
  },
};
</script>

<style scoped>
.navDrawerTitle {
  padding-top: 5% !important;
}
.navDrawerTabName {
  font-size: 1.1em;
}
</style>
